import { Controller } from "@hotwired/stimulus";

export default class PwaInstallController extends Controller {
  // If the user's browser supports the beforeinstallprompt event, we can use it to install the app. Otherwise,
  // we leave the event alone so that it will navigate to the instructions screen.
  install(event) {
    if (window.pwaInstallPrompt) {
      window.pwaInstallPrompt.prompt();
    }
  }
}

